import React, { useState } from 'react';
import { ContentState, convertToRaw, } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


const FormattedEditor = ({text}) => {
  let _contentState = ContentState.createFromText(text);
  const raw = convertToRaw(_contentState)
  const [contentState, setContentState] = useState(raw) 
  return (
    <div className="App">
      <Editor
        defaultContentState={contentState}
        onContentStateChange={setContentState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
      />
    </div>
  )
}

FormattedEditor.defaultProps = {
    text:""
};

export default FormattedEditor;
